const possibleTypes = {
  Template: ["Process", "Task"],
  UserGroupResult: ["User", "Group"],
  JobStepResponseBatch: ["FoodItemBatch"],
  KnowledgeV2: ["KnowledgeArticle", "KnowledgeFile", "KnowledgeTrainingModule"],
  TrainingModuleStep: [
    "TrainingModuleContentStep",
    "TrainingModuleVideoUrlStep",
    "TrainingModuleVideoUploadStep",
    "TrainingModuleScormUploadStep",
    "TrainingModuleSelectStep",
    "TrainingModuleMultipleChoiceStep",
    "TrainingModuleTrueFalseStep",
    "TrainingModuleOrderingStep",
    "TrainingModuleTextResponseStep",
    "TrainingModuleTextEntryStep",
    "TrainingModuleChecklistStep",
    "TrainingModuleSingleChoiceStep",
    "TrainingModuleMatchUpStep"
  ],
  SensorDevice: ["Sensor", "SensorGateway"],
  WorkflowTemplateStage: ["WorkflowTemplateProcessStage", "WorkflowTemplateApprovalStage"],
  ProcessStep: [
    "CommonProcessStep",
    "NumberProcessStep",
    "MultipleChoiceProcessStep",
    "ProcessProcessStep",
    "RandomizerProcessStep",
    "SelectionProcessStep",
    "TouchpointProcessStep"
  ],
  JobProcessStep: [
    "CheckboxJobStep",
    "DateTimeJobStep",
    "FilesJobStep",
    "InstructionJobStep",
    "LongTextJobStep",
    "MultipleChoiceJobStep",
    "NumberJobStep",
    "NumberRatingJobStep",
    "PhotosJobStep",
    "ProcessJobStep",
    "RandomizerJobStep",
    "SectionJobStep",
    "SelectionJobStep",
    "SignatureJobStep",
    "TemperatureTimerJobStep",
    "TextJobStep",
    "TouchpointJobStep"
  ],
  Printer: ["NetworkPrinter", "BluetoothPrinter", "BluetoothLowEnergyPrinter", "USBPrinter"]
}

export { possibleTypes }
